export type LastContext = Partial<Record<
  'insurance_type' | 'policy_type' | 'group' | 'subgroup' | 'insurer' | 'posp', string | null
>>;

// Classification fields only. `posp` is deliberately NOT carried over: the
// Agent is a per-policy commercial fact, not a form-filling convenience, and
// silently inheriting the last record's agent mis-attributes the sale (and its
// commission) to whoever happened to be on the previous policy.
// `LastContext` still declares `posp` because /policies/last-context/ returns
// it — it is accepted as input and dropped here.
// NOTE: PolicyCreatePage separately prefills `posp` when converting a QUOTE
// into a policy. That one is correct and intentional (the agent who worked the
// quote is the agent on the resulting policy) and is unaffected by this list.
export function applyLastContext(ctx: LastContext): Record<string, string> {
  const keys: (keyof LastContext)[] = ['insurance_type', 'policy_type', 'group', 'subgroup', 'insurer'];
  const patch: Record<string, string> = {};
  for (const k of keys) {
    const v = ctx[k];
    if (v) patch[k] = v;
  }
  return patch;
}
